module.exports = __webpack_public_path__ + "static/media/circle-notch.4cccc6b0.svg";